import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.whitelabelCompanyData, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_WHITELABEL_COMPANY_DATA}_SUCCESS`: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
